// 토큰 요청 URL
export const TOKEN_URL = "api/auth";

// 로그인 요청 URL
export const LOGIN_INFO_URL =  "api/login";

// 회원가입 요청 URL
export const JOIN_INFO_URL = "api/register";

// 본인인증 요청 URL
export const IDENTITY_VERIFICATION_URL = "api/auth/getNiceAccessToken";

// 아이디 사용가능한지 체크 URL
export const ID_CHECK_URL = "api/myIdCheck";

// 닉네임 사용 가능 체크 URL
export const NICKNAME_CHECK_URL = "api/nickCheck";

// 아이디 찾기 URL
export const ID_FIND_URL = "api/idFind";
//비밀번호 찾기 URL
export const PASSWORD_FIND_URL = "api/passwordFind";
// 비밀번호 재설정 URL
export const PASSWORD_RESET_URL = "api/passwordChange";

// 본인인증 회원정보 수정 URL
export const AUTH_VERIFICATION_INFO_EDIT_URL = "api/myVerificationUpdate";

// 점유인증 URL
export const INFORMATION_VERIFY_URL = "api/certification";
// 점유인증 확인
export const CERTIFICATION_CHECK = "api/certification_check";

// 카테고리 리스트
export const CATEGORY_LIST_URL = "api/categoryListInfo";

// join 포인트 값
export const JOIN_POINT_URL = "api/main/joinPoint";

// 데이터 리스트
export const DATA_LIST_URL = "api/main/displayGoods/list";
// 배너리스트 
export const BANNER_LIST_URL = "api/main/banner/list";

// 크레딧 리스트
export const CREDIT_LIST_URL = "api/main/credits/list";

// 브랜드 리스트
export const BRAND_LIST_URL = "api/brandListInfo";
// 브랜드 상세
export const BRAND_DETAIL_URL = "api/categoryGoodsList";

// Best 리스트
export const BEST_LIST_URL = "api/categoryBestList";
// Brand 제외 카테고리 리스트
export const BRAND_EXCLUDE_CATEGORY_LIST_URL = "api/getFullCategoryGoodsList";


// 신상 상세페이지
export const DETAIL_PAGE_URL = "api/goods/detail";
// 패키지 상품
export const PACKAGE_GOODS_URL = "api/goods/bundle";
// 관련 상품
export const RELATED_GOODS_URL = "api/goods/relation";
// 추천 상품
export const RECOMMEND_GOODS_URL = "api/goods/recommend";

// 장바구니 추가
export const CART_ADD_URL = "api/goods/cart";

// 장바구니 상세
export const CART_DETAIL_URL = "api/goods/cartList";

// 지점 리스트
export const STORE_LIST_URL = "api/storeList";

// 지점 상세
export const STORE_DETAIL_URL = "api/storeDetail";

// 배송지 정보
export const DELIVERY_INFO_URL = "api/goods/defaultDeliveryInfo";

// 배송지 리스트
export const DELIVERY_LIST_URL = "api/mypage/deliveryList";

// 배송지 삭제
export const DELIVERY_DELETE_URL = "api/mypage/deliveryDelete";

// 배송지 등록
export const DELIVERY_REGISTER_URL = "api/mypage/deliveryRegist";

// 배송지 수정
export const DELIVERY_EDIT_URL = "api/mypage/deliveryModify";

// 쿠폰 리스트
export const COUPON_LIST_URL = "api/goods/couponList";

// 예치금 정보
export const DEPOSIT_LIST_URL = "api/goods/depositList";
// 예치금 충전
export const DEPOSIT_CHARGE_URL = "api/mypage/balancePay";
// 예치금 환불
export const DEPOSIT_REFUND_URL = "api/mypage/balanceRefundPay";

// 은행 리스트
export const BANK_LIST_URL = "api/bankList";

// 리뷰 리스트
export const REVIEW_LIST_URL = "api/board/review/list";

// 1:1 문의 리스트, 커스터마이징 리스트
export const INQUIRY_LIST_URL = "api/board/common/list";

// 1:1 문의 상세, 커스터마이징 상세
export const INQUIRY_DETAIL_URL = "api/board/common/detail";

// 문의 등록
export const INQUIRY_REGISTER_URL = "api/board/common/upload";

// 1:1 문의 수정
export const INQUIRY_EDIT_URL = "api/board/common/modify";

// 1:1 문의 삭제
export const INQUIRY_DELETE_URL = "api/board/common/delete";

// 최저가 보장 가이드
export const PRICE_GUIDE_URL = "api/board/lowestGuide";

// 이벤트 리스트
export const EVENT_LIST_URL = "api/board/event/list";
// 이벤트 상세
export const EVENT_DETAIL_URL = "api/board/event/detail";

// 제작지원 마이페이지 리스트
export const MAKING_SUPPORT_MY_PAGE_LIST_URL = "api/mypage/myMakingApplyList";

// 예약하기 
export const RESERVATION_URL = "api/main/reservation";

// 좋아요 및 취소
export const LIKE_URL = "api/main/goods/like";

// 제작지원 리스트
export const MAKING_SUPPORT_LIST_URL = "api/board/produce/list";
// 제작지원 상세
export const MAKING_SUPPORT_DETAIL_URL = "api/board/produce/detail";
// 제작지원 등록
export const MAKING_SUPPORT_REGISTER_URL = "api/board/produce/upload";
// 제작지원 신청 상세
export const MAKING_SUPPORT_APPLY_DETAIL_URL = "api/board/produce/applyDetail";
// 제작지원 삭제
export const MAKING_SUPPORT_DELETE_URL = "api/board/produce/applyDelete";
// 제작지원 수정
export const MAKING_SUPPORT_EDIT_URL = "api/board/produce/update";

// 찜한 별당리스트
export const BOOKMARK_LIST_URL = "api/mypage/storeLikeList";

// 내정보 URL
export const MY_INFO_URL = "api/myInfo";

// 내정보 수정 URL
export const MY_INFO_EDIT_URL = "api/myInfoUpdate";

// 예약 내역 리스트
export const MY_RESERVATION_LIST_URL = "api/mypage/reservationCheckList";

// 리뷰 등록
export const REVIEW_REGISTER_URL = "api/board/review/upload";

// 리뷰 수정
export const REVIEW_EDIT_URL = "api/board/review/modify";

// 리뷰 상세 
export const REVIEW_DETAIL_URL = "api/board/review/detail";

// 리뷰 삭제
export const REVIEW_DELETE_URL = "api/board/review/delete";

//  검색
export const SEARCH_URL = "api/main/search";

// 회원 탈퇴 사유
export const WITHDRAWAL_REASON_URL = "api/mypage/leaveReasonList";

// 회원 탈퇴
export const WITHDRAWAL_URL = "api/mypage/leave";

// 공지사항 리스트
export const NOTICE_LIST_URL = "api/board/notice/list";

// 공지사항 상세
export const NOTICE_DETAIL_URL = "api/board/notice/detail";

// 자주하는질문 탭 리스트
export const FAQ_TAB_LIST_URL = "api/board/faq/type";

// 자주하는질문
export const FAQ_LIST_URL = "api/board/faq/list";

// 1:1 문의 탭 리스트
export const INQUIRY_TAB_LIST_URL = "api/board/common/type";

// 크레딧 리스트
export const COMM_CREDIT_LIST_URL = "api/board/credit/list";
// 크레딧 상세
export const COMM_CREDIT_DETAIL_URL = "api/board/credit/detail";

// 약관리스트
export const TERMS_LIST_URL = "api/termsList";

// 매장, 택배, 판매 총 개수 카운트 
export const MY_PAGE_ORDER_COUNT_URL = "api/goods/cartTypeCount";

// 마이페이지 주문 취소
export const MY_PAGE_ORDER_CANCEL_URL = "api/mypage/myRentalVisitCancel";

// 마이페이지 구매확정
export const MY_PAGE_ORDER_CONFIRM_URL = "api/mypage/myOrderDecide";

// 마이페이지 교환, 반품 신청 리스트
export const MY_PAGE_ORDER_EXCHANGE_RETURN_LIST_URL = "api/mypage/returnExchangeInfo";

// 교환, 반품 데이터 바뀔때 호출하는 api
export const MY_PAGE_ORDER_EXCHANGE_RETURN_UPDATE_URL = "api/mypage/calculAddPay";

// 마이페이지 교환, 반품 신청
export const MY_PAGE_ORDER_EXCHANGE_RETURN_URL = "api/mypage/returnExchangeApply";

// 마이페이지 메인 리스트
export const MY_PAGE_MAIN_LIST_URL = "api/mypage/myOrderList";

// 마이페이지 상세
export const MY_PAGE_DETAIL_URL = "api/mypage/myOrderDetail";

// 마이페이지 견적서 주문 리스트
export const MY_PAGE_ESTIMATE_ORDER_LIST_URL = "api/mypage/myOrderTypeList";

// 마이페이지 연장 페이지
export const MY_PAGE_EXTENSION_URL = "api/mypage/myRentalExtension";

// 마이페이지 재주문
export const MY_PAGE_REORDER_URL = "api/mypage/reorder";    

// 마이페이지 관심 상품
export const MY_PAGE_INTEREST_GOODS_URL = "api/mypage/goodsLikeList";

// 마이페이지 예치금 리스트
export const MY_PAGE_DEPOSIT_LIST_URL = "api/mypage/balanceTypeList";

// 총 예치금
export const MY_PAGE_DEPOSIT_TOTAL_URL = "api/mypage/balanceCurrent";

// 마이페이지 포인트 리스트
export const MY_PAGE_POINT_LIST_URL = "api/mypage/pointTypeList";

// 마이페이지 쿠폰 리스트
export const MY_PAGE_COUPON_LIST_URL = "api/mypage/couponList";

// 마이페이지 교환/ 반품 철회
export const MY_PAGE_ORDER_EXCHANGE_RETURN_CANCEL_URL = "api/mypage/myReturnExchangeCancel";

// 할인혜택 리스트 
export const DISCOUNT_BENEFIT_LIST_URL = "api/aboutus/memberBenefit";

// 푸터 데이터
export const FOOTER_DATA_URL = "api/footerInfo";

// 이용안내 데이터
export const INSTRUCTION_DATA_URL = "api/aboutus/useReason";

// 헤더 공지사항
export const HEADER_NOTICE_URL = "api/main/mainTopNotice";

// 재고 달력 api
export const STOCK_CALENDAR_URL = "api/goods/goodsStockStatus";

// 직원평가 api
export const EMPLOYEE_EVALUATION_URL = "api/mypage/orderManagerRating";

// 신고하기 api
export const REPORT_URL = "api/mypage/orderReport";

// 택배사 리스트
export const PARCEL_COMPANY_LIST_URL = "api/mypage/deliveryCompanyList";

// 택배 반납 직접 발송하기
export const PARCEL_RETURN_URL = "api/mypage/sendParcelDirectly";

// 예약 가이드
export const RESERVATION_GUIDE_URL = "api/aboutus/reservationGuide";

// 회사 소개 데이터
export const COMPANY_INTRO_URL = "api/aboutus/companyIntroList";

// 기업 연혁 데이터
export const COMPANY_HISTORY_URL = "/api/companyHistoryList";